# ---
# Сервис сессии
# ---
SessionService = Em.Service.extend
  # Инжектированные сервисы
  store: Em.inject.service()
  env:   Em.inject.service('environment')

  # state
  currentUser:         null
  currentOrganization: null
  noDeliveryZonesWithDelivery: false
  availableOrganizations: Em.A([])
  manyOrganizations: Em.computed.gt('availableOrganizations.length',1)


  # Вообще открытые заказы можно вынести в отдельный сервис из сессии
  openedOrders: Em.A({})
  # не получилось сделать реактивный байдинг на открытые заказы,
  # это свойство только для обновления интерфейса
  openedOrdersCount: 0

  hubspotUserHash: null
  intercomUserHash: null
  intercomUserId:   null

  locale: navigator.language.split('-')[0]

  multipleOrganizations: Em.computed.gt('availableOrganizations.length', 1)

  sessionUrl: (->
    "#{@get('env').get('apiRoot')}/api/session"
  ).property()

  google_token: (->
    # return "AIzaSyBma3uW6GRuPzKUUhibwaM0sbJzB-Hy5j0"

    # token = 'AIzaSyAnP4UGUfm08CAIFuHIozn0_DmE03Md9ko'

    token = 'AIzaSyBpF3QURi-LsPCUAxrcjCUcvLfs1VQWDEM' # актуальный токен
    # token = 'AIzaSyCj5FmfElgreTv-HHXb1GMJNHddEH3MCN8' # токен из учетки Максима
    @get('availableOrganizations').forEach (o) ->
      tokens = o.get('features.google_token')
      if tokens
        if Array.isArray(tokens)
          token = tokens[parseInt(Math.random() * tokens.length)]
        else
          token = tokens
    return token
  ).property('availableOrganizations')

  twoGis_token: (->
    # токен самоката
    return '388e8a07-f093-4da2-985b-6d45c47667af'
    # тестовый токен для геосаджестов
    # return 'd73e953e-3b2a-4d9b-915f-4c711a56a2bc'
    # return '72df8181-6863-4cde-abaa-2f92ab6f4824'
    # return '042b5b75-f847-4f2a-b695-b5f58adc9dfd'
    # return '661b122b-2136-40a1-b75a-fcdc4dda86fd'
    # return '3a838718-9760-4d75-8481-3351d07f6e62'
    # return '042b5b75-f847-4f2a-b695-b5f58adc9dfd'
  ).property('availableOrganizations')

  rateEnabled: (->
    rateEnabled = false
    @get('availableOrganizations').forEach (o) ->
      rateEnabled = true if o.get('features.client_can_rate')
    return rateEnabled
  ).property('availableOrganizations')

  currentMultilingualLanguage: ((key, value) ->
    storageKey      = 'currentMultilingualLanguage'
    locales = @get('multilingual.locales')

    return undefined unless locales

    if arguments.length > 1
      if value and locales.includes(value)
        localStorage.setItem storageKey, value
        # как-то надо это не тут и элегантнее, наверное :)
        window.location.reload()
      else
        localStorage.removeItem storageKey

    value = localStorage.getItem storageKey

    # Если локаль выбрана и организации уже загружены,
    # но в доступных локалях все еще нет выбранной локали — сбросить её
    if value and !Em.isEmpty(@get('availableOrganizations')) and !locales.includes(value)
      Em.run.later =>
        localStorage.removeItem storageKey
        window.location.reload()

      return undefined

    value

  ).property('features', 'availableOrganizations.[]')

  multilingual: (->
    locale = @get('locale')
    @get('availableOrganizations').forEach (o) ->
      locale = o.get('features.multilanguage')
    return locale
  ).property('availableOrganizations.[]')

  organization_locale: (->
    locale = @get('locale')
    @get('availableOrganizations').forEach (o) ->
      locale = o.get('features.locale')
    return locale
  ).property('availableOrganizations')

  yandex_token: (->
    # token = 'c0c11e15-25d2-49d3-a476-2362ff317132' # plan-b
    # token = 'dcd859bb-489b-40bd-970a-0789c8bf67c5' # smartomato (не работал почему-то)
    # token = '37c09330-ecce-4dda-8cfc-67ad0b6e9e63' # hatlam
    token = '7662882a-d116-4c76-90a8-4dd4af91eeb1' # смартомато (main)

    @get('availableOrganizations').forEach (o) ->
      incomeToken = if o.get('features.yandex_token') then o.get('features.yandex_token') else token
      token = if Array.isArray(incomeToken) then incomeToken[Math.floor(Math.random() * incomeToken.length)] else incomeToken
    return token
  ).property('availableOrganizations')

  board_domain: (->
    domain = @get('default_board_domain')
    @get('availableOrganizations').forEach (o) ->
      domain = o.get('features.board_domain') if o.get('features.board_domain')
    return domain
  ).property('availableOrganizations')

  logo_path: (->
    "./images/#{window.brand}-logo.png"
  ).property()

  brand: (->
    window.brand
  ).property()

  default_board_domain: (->
    'http://smartomato.ru/board'
  ).property()

  # Сессия под БК? Для всяких костылей
  isBK: (->
    @get('currentUser.organization_id') == 1869
  ).property('currentUser.organization_id')

  showDownloadCourierAppsLink:  Em.computed.not('isBK')

  restorePasswordUrl: (->
    "#{@get('env').get('apiRoot')}/api/session/restore_password"
  ).property()

  apiKeyLSPath: (->
    "#{@get('env.application')}_apiKey"
  ).property('env.application')

  isLC: Em.computed.alias('currentUser.isLogisticsStaff')

  # ---
  # Матрица прав доступа
  # ---
  accessRights: (->
    console.log(@get('env').get('features'))
    user = @get('currentUser')
    return null unless user

    env = @get('env')

    isStaffAdmin          = user.get('isStaffMember') and user.get('account.isAdmin')
    isStaffRegionalAdmin  = user.get('isStaffMember') and user.get('account.isRegionalAdmin')
    isStaffManager        = user.get('isStaffMember') and user.get('account.isManager')
    isStaffLogist         = user.get('isStaffMember') and user.get('account.isLogist')
    isStaffManagerLogist  = user.get('isStaffMember') and user.get('account.isManagerLogist')

    isDispatcher          = user.get('isDispatcher')

    isLCAdmin             = user.get('isLogisticsStaff') and user.get('account.isAdmin')
    isLCManagerLogist     = user.get('isLogisticsStaff') and user.get('account.isManagerLogist')
    isLCLogist            = user.get('isLogisticsStaff') and user.get('account.isLogist')
    isLCManager           = user.get('isLogisticsStaff') and user.get('account.isManager')

    isAdmin               = isStaffAdmin          or isLCAdmin
    isManager             = isStaffManager        or isLCManager
    isLogist              = isStaffLogist         or isLCLogist
    isManagerLogist       = isStaffManagerLogist  or isLCManagerLogist
    {
      sandbox:              @get('env').get('isDevelopment')
      organizations:        false
      couriers:             isAdmin or isManagerLogist or isStaffRegionalAdmin
      # restricted_couriers:  isStaffManagerLogist
      orders:               true

      # Если это пользователь ЛЦ, но в ЛЦ нет ни одной зоны с доставкой — скрываем пункт меню доставки для него
      # Чтобы не грузить прямо здесь список зон, признак приходит из контроллера App.OrdersController
      #
      # вероятно можно было бы скрывать и для обычных менеджеров логистов,
      # т.к. зоны для них ридонли и если доставок нет — смотреть там нечего, но пока они видят всегда
      delivery:             isAdmin or isStaffManagerLogist or (isLCManagerLogist and !@get('noDeliveryZonesWithDelivery')) or isStaffRegionalAdmin

      deliveryZones:        isAdmin or isManagerLogist or isStaffRegionalAdmin
      deliveryZonesEdit:    isAdmin or isStaffRegionalAdmin
      themes:               isStaffAdmin
      categories:           isAdmin or isManager or isManagerLogist or isStaffRegionalAdmin
      menuEdit:             isAdmin
      restaurantPricesEdit: isAdmin or isStaffRegionalAdmin
      restaurants:          isAdmin or isManagerLogist or isStaffRegionalAdmin
      restaurantEdit:       isAdmin or isStaffRegionalAdmin
      restaurantDisable:    isAdmin or isManagerLogist or isStaffRegionalAdmin
      billing:              isStaffAdmin
      profile:              true
      staff:                isAdmin or isStaffRegionalAdmin
      businessRole:         isAdmin
      staffCreateAdmin:     isAdmin
      sip:                  isAdmin
      yandex_business:      isAdmin if env.get('locale') ==  'ru'
      organizationSettings: isAdmin
      analytics:            env.get('features.web_analytics') and isStaffAdmin
      clients:              (isAdmin or isLogist or isManagerLogist or isStaffRegionalAdmin) and env.get('features.clientCRM')
      communicationChannels: env.get('features.communicationChannels')
      staticPages:          isAdmin and env.get('features.boardEnableStaticPagesEdit')
      map:                  env.get('features.orderMap')
      promos:               (isStaffAdmin) and env.get('features.promosEnabled')
      loyaltyPrograms:      (isStaffAdmin) and env.get('features.loyaltyProgramsEnabled')
      mobileApp:            (isStaffAdmin) and env.get('features.hasMobileApplication')
      orderCreate:          (isAdmin or isLogist or isManagerLogist or isStaffRegionalAdmin) and env.get('features.orderCreate')
      clientDelete:         isAdmin
      orderDelete:          isAdmin or isStaffRegionalAdmin
      orderEdit:            isAdmin or isLogist or isManagerLogist or isStaffRegionalAdmin
      orderLogistics:       isAdmin or isLogist or isManagerLogist  or isStaffRegionalAdmin
      utilities:            isAdmin
      canMuteCancelSms:     isAdmin or isStaffRegionalAdmin or !env.get('features.restrictManagerMuteCancelSms')
      canExportOrders:      isAdmin or !env.get('features.restrictExportToAdmin')
      canExportClients:     isAdmin or !env.get('features.restrictExportToAdmin')
      reports:              env.get('features.reports') # and (isAdmin or isLogist or isManagerLogist or isStaffRegionalAdmin)
    }
  ).property('currentUser', 'env', 'noDeliveryZonesWithDelivery', 'env.features.promosEnabled')

  # ---
  # Подгружает нужные свойства при смене организации
  # ---
  loadBillingInfo: (->
    if !(@get('currentUser.account.isAdmin') and @get('currentUser.isStaffMember'))
      @set('currentBilling', null)
      return

    organization = @get('currentOrganization')

    unless organization
      return @set('currentBilling', null)

    @get('store').fetchById('billingInfo', 0)
    .then (billing) =>
      @set('currentBilling', billing)
    .catch =>
      @set('currentBilling', null)
  ).observes(
    'currentUser.isStaffMember'
    'currentUser.account.isAdmin',
    'currentOrganization')

  updateCurrency: (->
    currency = @get('currentOrganization.currency')

    return unless currency

    @get('env').set('currency', currency)
    @set('currency', currency)
  ).observes('currentOrganization.currency')

  initGoogle: ->
    # TODO это инициализация должна происходить при соответствующей настройке и токен должен приходить с сервера
    loc = window.location.href.replace('https:','http:')
    if @get('default_board_domain') != @get('board_domain') && loc.indexOf(@get('default_board_domain')) > -1
      window.location.href = @get('board_domain') + "#/cross-login/#{@get('apiKey')}"
      return

    src = "https://maps.googleapis.com/maps/api/js?key=#{@get('google_token')}&v=3.exp&libraries=visualization,places&language=#{@get('organization_locale')}"
    s = document.createElement 'script'
    s.setAttribute 'src', src
    document.body.appendChild s

  init2Gis: ->
    src = "https://mapgl.2gis.com/api/js/v1"
    s = document.createElement 'script'
    s.setAttribute 'src', src
    document.body.appendChild s

  checkSSL: ->
    if window.location.protocol == 'http:' && window.location.href.indexOf('.test') == -1
      window.location.href = "http://#{window.location.host}/#/cross-login/#{@get('apiKey')}"
      return true
    return true

  ###
  # Intercom stuff
  ###
  initIntercom: ->
    new Em.RSVP.Promise (resolve, reject) =>
      return resolve() unless @get('env.intercomEnabled')

      userHash  = @get('intercomUserHash')
      userEmail = @get('currentUser.login')
      userId    = @get('intercomUserId') || @get('currentUser.id')
      appId     = @get('env.intercomAppId')

      Em.Logger.info "Инициализируем Intercom: #{userHash}, #{userEmail}, #{userId}"

      if [ appId, userHash, userId, userEmail ].any(Em.isEmpty)
        Em.Logger.error "Не удалось инициализировать Intercom, недостаточно данных для инициализации!"
        return resolve()

      Intercom?('boot', {
        app_id:    appId,
        email:     userEmail if @get('currentUser.account.emailConfirmed'),
        user_id:   userId,
        user_hash: userHash
      })

      resolve()

  # Hubspot
  initHubspot: ->
    new Em.RSVP.Promise (resolve, reject) =>
      userHash  = @get('hubspotUserHash')
      return resolve() unless userHash

      userEmail = @get('currentUser.login')
      # userFirstName = @get('currentUser.name')
      # userId    = @get('intercomUserId') || @get('currentUser.id')
      # appId     = @get('env.intercomAppId')

      Em.Logger.info "Инициализируем Hubspot: #{userHash}, #{userEmail}"

      if [ userHash, userEmail ].any(Em.isEmpty)
        Em.Logger.error "Не удалось инициализировать Hubspot, недостаточно данных для инициализации!"
        return resolve()

      window.hsConversationsSettings = {
        identificationEmail: userEmail,
        identificationToken: userHash
      };
      window.HubSpotConversations?.widget.load();

      resolve()

  shutdownIntercom: ->
    new Em.RSVP.Promise (resolve, reject) =>
      return resolve() unless @get('env.intercomEnabled')
      Em.Logger.info "Тушим Intercom..."

      resolve( Intercom?('shutdown') )

  loadCurrentUserData: (data) ->
    new Em.RSVP.Promise (resolve, reject) =>
      @get('store').pushPayload('api_user', data)
      user = @get('store').getById('api_user', data.api_user.id)

      @set('currentUser', user)

      if user.get('isStaffMember')
        user.get('account.organization').then (organization) =>
          @set('currentOrganization', organization)
          @get('availableOrganizations').pushObject(organization)
          @get('env').mergeFeatures(organization.get('features') || {})
          resolve(user)

      else if user.get('isLogisticsStaff')
        user.get('account.logistics_center').then (logisticCenter) =>
          @set('currentLogisticsCenter', logisticCenter)

          @get('store').find('organization', {}).then (organizations) =>
            @set('currentOrganization', organizations.get('content.0'))
            @get('availableOrganizations').pushObjects(organizations.get('content'))
            resolve(user)
          , reject
        , reject

      else
        @set('currentOrganization', null)
        resolve(user)

  # ---
  # Загружает пользователя в store через payload
  # ---
  assignCurrentUser: (data) ->
    meta = data.meta
    delete data['meta']

    @set('hubspotUserHash', meta.hubspot_user_hash)
    @set('intercomUserHash', meta.intercom_user_hash)
    @set('intercomUserId',   meta.intercom_user_id)

    @set('locale',   meta.locale)

    loadedUser = null

    @loadCurrentUserData(data)
    .then (user) =>
      if @checkSSL()
        loadedUser = user
        @initIntercom()
        @initHubspot()
        @initGoogle()
        @init2Gis()
    .then =>
      loadedUser


  restorePassword: (email, gCaptchaResponse) ->
    new Em.RSVP.Promise (resolve, reject) =>
      Em.$.post(@get('restorePasswordUrl'), { email, 'g-recaptcha-response': gCaptchaResponse })
      .then (data) =>
        resolve()
      .fail =>
        reject()

  login: (login, password) ->
    new Em.RSVP.Promise (resolve, reject) =>
      Em.$.post(@get('sessionUrl'), { login, password })
      .then (data) =>
        @set('apiKey', data.meta.token)
        @assignCurrentUser(data).then(resolve, reject)
      .fail =>
        reject()

  # ---
  # Пытается загрузить текущего пользователя по сохраненному ключу
  # ---
  loadUser: ->
    new Em.RSVP.Promise (resolve, reject) =>
      key = @get('apiKey')

      unless key
        Em.Logger.log "API-ключ не был найден в #{@get('apiKeyLSPath')}"
        return reject()

      Em.Logger.log "Проверяем валидность ключа GET #{@get('sessionUrl')}"

      Em.$.ajax(
        method: 'GET'
        url: @get('sessionUrl')
        headers: 'Authorization': "Token token=\"#{key}\""
        xhrFields:
          withCredentials: true
      ).then (data) =>
        @assignCurrentUser(data).then(resolve, reject)
      , =>
        @set('apiKey', null)
        reject()

  # ---
  # API-ключ в LS
  # ---
  apiKey: ((key, value) ->
    storageKey      = @get('apiKeyLSPath')

    if arguments.length > 1
      if value
        localStorage.setItem storageKey, value
      else
        localStorage.removeItem storageKey

    localStorage.getItem storageKey
  ).property()

  loggedIn: (->
    not Em.isEmpty @get('apiKey')
  ).property('apiKey')

  logout: ->
    @shutdownIntercom()
    @set('apiKey', null)
    @set('currentUser', null)
    @set('currentOrganization', null)
    @set('currentLogisticsCenter', null)
    @get('availableOrganizations').clear()
    @get('store').unloadAll()

  endSession: ->
    Em.$.ajax(
      method: 'DELETE'
      url: @get('sessionUrl')
      headers: 'Authorization': "Token token=\"#{@get('apiKey')}\""
    ).then @logout()


module.exports = SessionService
